// src/components/TermsOfUseModal/index.tsx
import { FC } from 'react';
import { Modal, Drawer, Button, ConfigProvider } from 'antd';
import { useTranslation } from 'react-i18next';
import { getAuthLightThemeConfig } from '@/theme/antdTheme';
import useIsMobile from '@/hooks/useIsMobile';
import SvgIcon from '@/components/SvgIcon';
import EnContent from './content/en';
import FrContent from './content/fr';
import styles from './index.module.scss';

interface TermsOfUseModalProps {
  open: boolean;
  onClose: () => void;
}

const TermsOfUseModal: FC<TermsOfUseModalProps> = ({ open, onClose }) => {
  const { t, i18n } = useTranslation();
  const isMobile = useIsMobile(768);
  const isTablet = useIsMobile(1024);

  // 根据当前语言选择内容组件
  const ContentComponent = i18n.language === 'fr' ? FrContent : EnContent;

  // 手机端使用 Drawer
  if (isMobile) {
    return (
      <ConfigProvider theme={getAuthLightThemeConfig()}>
        <Drawer open={open} onClose={onClose} placement="bottom" height="90vh" className={styles.termsDrawer} destroyOnClose>
          <div className={styles.mobileHeader}>
            <h2 className={styles.mobileTitle}>{t('termsOfUse.modalTitle')}</h2>
            <button className={styles.mobileCloseBtn} onClick={onClose} type="button" aria-label="Close">
              <SvgIcon name="x-black" size={24} />
            </button>
          </div>
          <div className={styles.mobileContent}>
            <div className={styles.content}>
              <ContentComponent />
            </div>
          </div>
          <div className={styles.mobileFooter}>
            <Button type="primary" size="large" onClick={onClose}>
              {t('termsOfUse.close')}
            </Button>
          </div>
        </Drawer>
      </ConfigProvider>
    );
  }

  // 平板/桌面端使用 Modal
  return (
    <ConfigProvider theme={getAuthLightThemeConfig()}>
      <Modal
        open={open}
        onCancel={onClose}
        title={t('termsOfUse.modalTitle')}
        footer={
          <Button type="primary" onClick={onClose}>
            {t('termsOfUse.close')}
          </Button>
        }
        width={isTablet ? 'calc(100vw - 80px)' : 680}
        centered
        className={styles.termsModal}
        destroyOnClose
      >
        <div className={styles.content}>
          <ContentComponent />
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default TermsOfUseModal;
